import CompoundCoursePart from "@/models/CompoundCoursePart";
import CourseRun from "@/models/CourseRun";

export default class LiveCourseParticipant {
    constructor(raw = {}) {
        this.id = raw.id;
        this.name = raw.name;
        this.userName = raw.userName;
        this.courseRunDTO = new CourseRun(raw.courseRunDTO);
    }
}
